import { getGlobalParams, getCustomIntl } from 'config/config'

const { countryConfig } = getGlobalParams()
const { assetClassOrder, investmentRegionOrder, dividendTypeOrder, fundRatingOrder, msRatingOrder, currencyOrder } =
  countryConfig.categoriesOrders

const getGroupRules = () => {
  const intl = getCustomIntl()

  return {
    defaultGroupOption: 'fundRangeCode.longName',
    groupOptions: [
      {
        value: 'fundRangeCode.longName',
        key: 'fundRangeCode',
        label: intl.formatMessage({ id: 'fundList.group.categories.FUND_RANGE' })
      },
      {
        value: 'fundName.zh',
        key: 'fundName',
        label: intl.formatMessage({ id: 'fundList.group.categories.FUND_NAME' })
      },
      {
        value: 'assetClass.name',
        key: 'assetClass',
        label: intl.formatMessage({ id: 'fundList.group.categories.ASSET_CLASS' }),
        order: assetClassOrder
      },
      {
        value: 'investmentRegion',
        key: 'investmentRegion',
        label: intl.formatMessage({ id: 'fundList.group.categories.REGION' }),
        order: investmentRegionOrder
      },
      {
        value: 'dividendType',
        key: 'dividendType',
        label: intl.formatMessage({ id: 'fundList.group.categories.DIVIDEND_TYPE' }),
        order: dividendTypeOrder
      },
      {
        value: 'fundRating',
        key: 'fundRating',
        label: intl.formatMessage({ id: 'fundList.group.categories.RISK_RATING' }),
        order: fundRatingOrder
      },
      {
        value: 'msRating.ratingName',
        key: 'msRating',
        label: intl.formatMessage({ id: 'fundList.group.categories.MORNINGSTAR_RATING' }),
        order: msRatingOrder
      },
      {
        value: 'currency.name',
        key: 'currency',
        label: intl.formatMessage({ id: 'fundList.group.categories.FUND_CURRENCY' }),
        order: currencyOrder
      },
      {
        value: 'shareClassType',
        key: 'shareClassType',
        label: intl.formatMessage({ id: 'fundList.group.categories.SHARE_TYPE' })
      },
      {
        value: 'none',
        key: '',
        label: intl.formatMessage({ id: 'fundList.group.categories.NONE' })
      }
    ]
  }
}

export default getGroupRules
